<template>
  <div class="popup-main">
    <el-dialog
      :title="detailId ? '送货单编辑' : '送货单新增'"
      width="1200px"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
    >
      <div>
        <e-form
          ref="refForm"
          :config="formConfig"
          :column="formColumn"
          :rules="formRules"
          :data.sync="selfDetail.form_data"
        />
        <vxe-grid
          ref="refTable"
          :min-height="tableConfig.minHeight"
          :toolbar-config="tableConfig.toolbarConfig"
          :edit-config="tableConfig.editConfig"
          :row-config="tableConfig.rowConfig"
          :mouse-config="tableConfig.mouseConfig"
          :keyboard-config="tableConfig.keyboardConfig"
          :columns="tableColumn"
          :data="selfDetail.goods_list"
          :show-footer="!!selfDetail.goods_list.length"
          :footer-method="footerMethod"
        >
          <!-- slot_default -->
          <template #default_operate="{ rowIndex }">
            <el-link
              class="f-s-16 iconfont icon-delete"
              title="删行"
              @click="itemDelete(rowIndex)"
            />
          </template>

          <!-- slot_edit -->
          <template #edit_goods_name="{ row }">
            <el-input v-model="row.goods_name" size="mini" clearable />
          </template>
          <template #edit_goods_spec="{ row }">
            <el-input v-model="row.goods_spec" size="mini" clearable />
          </template>
          <template #edit_goods_unit="{ row }">
            <el-input v-model="row.goods_unit" size="mini" clearable />
          </template>
          <template #edit_song_huo_count="{ row }">
            <el-input
              v-model="row.song_huo_count"
              type="number"
              size="mini"
              clearable
              @blur="countsBlur(row)"
            />
          </template>
          <template #edit_song_huo_price="{ row }">
            <el-input
              v-model="row.song_huo_price"
              type="number"
              size="mini"
              clearable
              @blur="countsBlur(row)"
            />
          </template>
          <template #edit_goods_remark="{ row }">
            <el-input v-model="row.goods_remark" size="mini" clearable />
          </template>
        </vxe-grid>
      </div>
      <div slot="footer">
        <div class="flex flex-y-center flex-x-between">
          <div class="flex flex-y-center">
            <el-button size="mini" type="default" @click="itemAdd()">新增行</el-button>
            <el-button v-if="!billId" size="mini" type="default" @click="popupChooseOrder">
              选择销售订单
            </el-button>
          </div>
          <div class="flex flex-y-center">
            <el-button size="mini" @click="popupCancel">取消</el-button>
            <el-button size="mini" type="primary" @click="popupPush(false)">
              {{ detailId ? '保存' : '创建' }}
            </el-button>
            <el-button size="mini" type="primary" @click="popupPush(true)"> 打印预览 </el-button>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 弹窗-选择销售订单 -->
    <PopupChooseOrder
      v-if="isShowPopupChooseOrder"
      :show.sync="isShowPopupChooseOrder"
      @success="updateUpdateChooseOrder"
    />
  </div>
</template>

<script>
export default {
  components: {
    PopupChooseOrder: () => import('./popup-choose-order')
  },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    isAdmin: {
      type: Boolean,
      required: true
    },
    detailId: {
      type: [Number, String],
      default: ''
    },
    billId: {
      type: [Number, String],
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selfShow: false,
      selfDetail: {
        form_data: {
          delivery_id: '', // 送货单id
          delivery_code: '', // 送货单号
          delivery_date: this.$XEUtils.toDateString(this.$XEUtils.now(), 'yyyy-MM-dd'), // 发货日期
          delivery_status: false, // 审核状态
          bill_code: '', // 销售单号
          customer_name: '', // 客户
          customer_id: '', // 客户id
          customer_uuid: '', // 客户uuid
          bu_men_name: '', // 制单部门
          bu_men_id: '', // 制单部门id
          saler_name: '', // 制单人
          saler_id: '', // 制单人id
          gong_cheng_fu_ze_ren_id: '', // 工程负责人id
          gong_cheng_fu_ze_ren_name: '', // 工程负责人
          pmc_fu_ze_ren_id: '', // PMC负责人id
          pmc_fu_ze_ren_name: '', // PMC负责人
          saler_company_name: '' // 开单公司
        },
        goods_list: []
      },
      customerList: [],
      customerKeyword: '',
      gongChengFuZeRenList: [], // 工程负责人下拉
      pmcFuZeRenList: [], // PMC负责人下拉
      formConfig: {
        inline: true,
        width: '386px'
      },
      formColumn: [
        {
          type: 'text',
          title: '送货单号',
          field: 'delivery_code',
          placeholder: '自动生成',
          disabled: true
        },
        {
          type: 'text',
          title: '销售单号',
          field: 'bill_code',
          placeholder: '可选，通过选择订单填充',
          disabled: true
        },
        {
          type: 'text',
          title: '制单人',
          field: 'saler_name',
          disabled: true
        },
        {
          type: 'select',
          title: '工程负责人',
          field: 'gong_cheng_fu_ze_ren_id',
          options: [],
          fnChange: () => {
            this.fuZeRenChoose('gong_cheng_fu_ze_ren_id', 'gong_cheng_fu_ze_ren_name')
          }
        },
        {
          type: 'select',
          title: 'PMC负责人',
          field: 'pmc_fu_ze_ren_id',
          options: [],
          fnChange: () => {
            this.fuZeRenChoose('pmc_fu_ze_ren_id', 'pmc_fu_ze_ren_name')
          }
        },
        {
          type: 'select',
          title: '客户',
          field: 'customer_uuid',
          options: [],
          remote: true,
          remoteMethod: (val) => {
            this.customerKeyword = val
            this.getCustomerList(true)
          }
        },
        {
          type: 'select',
          title: '开单公司',
          field: 'saler_company_name',
          options: this.$constant.companyList
        },
        {
          type: 'date',
          title: '发货日期',
          field: 'delivery_date',
          format: 'yyyy-MM-dd',
          valueFormat: 'yyyy-MM-dd'
        },
        {
          type: 'text',
          title: '备注',
          field: 'remark',
          width: '772px'
        },
        {
          type: 'switch',
          title: '审核状态',
          field: 'delivery_status',
          hide: !this.isAdmin
        }
      ],
      formRules: {
        customer_uuid: [{ required: true, message: '请选择客户' }],
        saler_company_name: [{ required: true, message: '请选择开单公司' }],
        delivery_date: [{ required: true, message: '请选择发货日期' }]
      },
      tableColumn: [
        {
          fixed: 'left',
          title: '序号',
          type: 'seq',
          width: 40
        },
        {
          title: '品名',
          field: 'goods_name',
          slots: { edit: 'edit_goods_name' },
          editRender: { autofocus: '.el-input__inner' }
        },
        {
          title: '规格',
          field: 'goods_spec',
          slots: { edit: 'edit_goods_spec' },
          editRender: { autofocus: '.el-input__inner' }
        },
        {
          title: '单位',
          field: 'goods_unit',
          slots: { edit: 'edit_goods_unit' },
          editRender: { autofocus: '.el-input__inner' }
        },
        {
          title: '送货数量',
          field: 'song_huo_count',
          slots: { edit: 'edit_song_huo_count' },
          editRender: { autofocus: '.el-input__inner' }
        },
        {
          title: '单价(元)',
          field: 'song_huo_price',
          slots: { edit: 'edit_song_huo_price' },
          editRender: { autofocus: '.el-input__inner' }
        },
        {
          title: '送货金额(元)',
          field: 'song_huo_amount'
        },
        {
          title: '备注',
          field: 'goods_remark',
          slots: { edit: 'edit_goods_remark' },
          editRender: { autofocus: '.el-input__inner' }
        },
        { title: '操作', slots: { default: 'default_operate' } }
      ],
      defaultObj: {
        goods_id: '',
        stock2_id: null,
        goods_name: '',
        goods_spec: '',
        goods_unit: '',
        goods_count: '',
        goods_price: '',
        goods_amount: '',
        goods_remark: '',
        song_huo_count: '',
        song_huo_price: '',
        song_huo_amount: ''
      },
      isShowPopupChooseOrder: false
    }
  },
  computed: {
    // 表格配置合并
    tableConfig() {
      let disabled = this.disabled
      let obj = {
        editConfig: {
          beforeEditMethod() {
            return !disabled
          }
        },
        keyboardConfig: {
          isEdit: !disabled
        }
      }
      let result = this.$util.deepMerge(this.$constant.tableDefaultConfig, obj)
      return result
    },
    selfAccountData() {
      let result = this.$store.getters.getLoginAccount
      return result
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    }
  },
  mounted() {
    this.selfShow = this.show
    if (this.detailId) {
      // 编辑：客户/负责人下拉统一在详情加载完成后拉取，避免 appendSelected* 读不到已选值
      this.getDetailData()
    } else {
      this.selfDetail.form_data.bu_men_name = this.selfAccountData.bu_men_name.join(',')
      this.selfDetail.form_data.bu_men_id = this.selfAccountData.bu_men_id.join(',')
      this.selfDetail.form_data.saler_name = this.selfAccountData.nick_name
      this.selfDetail.form_data.saler_id = this.selfAccountData.id
      this.getGongChengFuZeRenList()
      this.getPmcFuZeRenList()
      this.getCustomerList()
      if (this.billId) this.getBillDetail()
    }
  },
  methods: {
    // 获取-详情数据
    getDetailData() {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/songHuo4/detail',
        params: {
          delivery_id: this.detailId
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          this.selfDetail = this.$util.deepCopy(res.data.data)
          // 详情加载后重新拉取下拉，保证已选但已停用/不在默认候选中的账号、客户能正常回显
          this.getGongChengFuZeRenList()
          this.getPmcFuZeRenList()
          this.getCustomerList()
        }
      })
    },
    // 获取销售订单详情
    getBillDetail() {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/checkBill2/detail',
        params: {
          id: this.billId
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          let result = this.$util.deepCopy(res.data)
          result.bill_code = result.formData.bill_code
          result.company_name = result.formData.company_name
          result.company_uuid = result.formData.company_uuid
          result.saler_company_name = result.formData.saler_company_name
          // 一并传递核算单表头的负责人字段，给新建页面预预览可继承的负责人（updateUpdateChooseOrder 仅在当前为空时写入）
          result.gong_cheng_fu_ze_ren_id = result.formData.gong_cheng_fu_ze_ren_id
          result.gong_cheng_fu_ze_ren_name = result.formData.gong_cheng_fu_ze_ren_name
          result.pmc_fu_ze_ren_id = result.formData.pmc_fu_ze_ren_id
          result.pmc_fu_ze_ren_name = result.formData.pmc_fu_ze_ren_name
          this.updateUpdateChooseOrder(result)
        }
      })
    },
    // 获取客户列表
    getCustomerList() {
      this.$api({
        method: 'post',
        url: '/admin/customers/search',
        data: {
          keyword: this.customerKeyword,
          pageSize: 200
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          let result = res.data.page.list.map((item) => {
            return {
              key: item.customer_name,
              val: item.company_uuid,
              id: item.id
            }
          })
          // 已选客户不在搜索结果（前 200 条）中时，用已落库的 customer_name 补进去，
          // 避免编辑回显时 el-select 匹配不到 option 而直接显示原始 uuid
          this.appendSelectedCustomer(result)
          this.customerList = result
          this.formColumn.forEach((item) => {
            if (item.field === 'customer_uuid')
              item.options = this.$util.deepCopy(this.customerList)
          })

          // 用于客户编辑保存成功
          this.customerList.forEach((item) => {
            if (item.val === this.selfDetail.form_data.customer_uuid) {
              this.selfDetail.form_data.customer_name = item.key
              this.selfDetail.form_data.customer_id = item.id
            }
          })
        }
      })
    },
    // 获取-工程负责人列表（按部门/角色筛选“工程师”）
    getGongChengFuZeRenList() {
      this.getFuZeRenList(
        '工程师',
        'gong_cheng_fu_ze_ren_id',
        'gong_cheng_fu_ze_ren_name',
        'gongChengFuZeRenList'
      )
    },
    // 获取-PMC负责人列表（按部门/角色筛选“PMC跟单”）
    getPmcFuZeRenList() {
      this.getFuZeRenList('PMC跟单', 'pmc_fu_ze_ren_id', 'pmc_fu_ze_ren_name', 'pmcFuZeRenList')
    },
    // 负责人下拉统一取数接口：/admin/account/getAccountOptionList（仅登录、无需 action 权限点），
    // 不按登录账号做数据权限过滤，返回全部启用中的员工，仅支持用 role_name 模糊筛选部门/角色
    getFuZeRenList(roleName, idField, nameField, listKey) {
      this.$api({
        method: 'post',
        url: '/admin/account/getAccountOptionList',
        data: {
          filterData: {
            role_name: roleName
          },
          pageSize: this.$constant.pageMax
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          const list = res.data.page.list.map((item) => ({
            key: item.nick_name,
            val: item.id
          }))
          // 已选负责人不在候选列表（如已停用）时补充进去，保证回显
          this.appendSelectedFuZeRen(list, idField, nameField)
          this[listKey] = list
          this.formColumn.forEach((col) => {
            if (col.field === idField) {
              col.options = this.$util.deepCopy(list)
            }
          })
        }
      })
    },
    // 追加已选但不在下拉列表中的客户，保证编辑回显时显示客户名称而非原始 uuid
    appendSelectedCustomer(list) {
      const uuid = this.selfDetail.form_data.customer_uuid
      const name = this.selfDetail.form_data.customer_name
      if (!uuid || !name) return
      const isExist = list.some((item) => item.val === uuid)
      if (!isExist) {
        list.unshift({ key: name, val: uuid, id: this.selfDetail.form_data.customer_id })
      }
    },
    // 追加已选但不在下拉列表中的负责人，保证停用账号也能正常回显
    appendSelectedFuZeRen(list, idField, nameField) {
      const id = this.selfDetail.form_data[idField]
      const name = this.selfDetail.form_data[nameField]
      if (!id || !name) return
      const isExist = list.some((item) => item.val === id)
      if (!isExist) list.unshift({ key: name, val: id })
    },
    // 负责人选择联动：选中 id 后回填对应 name；清空时同步清空 name
    fuZeRenChoose(idField, nameField) {
      const id = this.selfDetail.form_data[idField]
      let name = ''
      if (id) {
        const list =
          idField === 'gong_cheng_fu_ze_ren_id' ? this.gongChengFuZeRenList : this.pmcFuZeRenList
        const target = list.find((item) => item.val === id)
        if (target) name = target.key
      }
      this.selfDetail.form_data[nameField] = name
    },
    // 项-新增
    itemAdd() {
      let result = this.$util.deepCopy(this.defaultObj)
      this.selfDetail.goods_list.push(result)
    },
    // 项-删除
    async itemDelete(index) {
      if (this.selfDetail.goods_list.length > 1) {
        this.selfDetail.goods_list.splice(index, 1)
      } else {
        this.selfDetail.goods_list[index] = this.$util.deepCopy(this.defaultObj)
      }
    },
    // 表格底部
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) return '合计'
          if (['song_huo_count', 'song_huo_price', 'song_huo_amount'].includes(column.field)) {
            return this.$util.listFieldTotal(data, column.field)
          }
        })
      ]
    },
    // 送货数量/单价-失焦：同步金额，并回填 goods_* 口径（后端单头合计 song_huo_total 按 goods_amount 汇总，手工行不同步会落空）
    countsBlur(row) {
      row.song_huo_amount = this.$XEUtils.multiply(row.song_huo_price, row.song_huo_count)
      row.goods_count = row.song_huo_count
      row.goods_price = row.song_huo_price
      row.goods_amount = row.song_huo_amount
    },
    // 弹窗-选择销售订单
    popupChooseOrder() {
      this.isShowPopupChooseOrder = true
    },
    // 弹窗-更新选择销售订单（追加填充，不覆盖已手填的表头和已录入的明细行）
    updateUpdateChooseOrder(row) {
      if (!this.selfDetail.form_data.bill_code) {
        this.selfDetail.form_data.bill_code = row.bill_code
      }
      if (!this.selfDetail.form_data.customer_uuid) {
        this.selfDetail.form_data.customer_name = row.company_name
        this.selfDetail.form_data.customer_uuid = row.company_uuid
        this.selfDetail.form_data.customer_id = row.company_id
      }
      if (!this.selfDetail.form_data.saler_company_name) {
        this.selfDetail.form_data.saler_company_name = row.saler_company_name
      }
      // 负责人继承：当前为空且上游行带了才写入（上游可能无行，保持不覆盖用户已选）
      if (!this.selfDetail.form_data.gong_cheng_fu_ze_ren_id && row.gong_cheng_fu_ze_ren_id) {
        this.selfDetail.form_data.gong_cheng_fu_ze_ren_id = row.gong_cheng_fu_ze_ren_id
        this.selfDetail.form_data.gong_cheng_fu_ze_ren_name = row.gong_cheng_fu_ze_ren_name || ''
      }
      if (!this.selfDetail.form_data.pmc_fu_ze_ren_id && row.pmc_fu_ze_ren_id) {
        this.selfDetail.form_data.pmc_fu_ze_ren_id = row.pmc_fu_ze_ren_id
        this.selfDetail.form_data.pmc_fu_ze_ren_name = row.pmc_fu_ze_ren_name || ''
      }
      const orderRows = (row.tableSaleData || []).map((item) => {
        let obj = {
          goods_id: '',
          // 核算单明细主键：超送校验、已送货数回写、核算单「未送货数」都靠它关联；手工自由新增行为 null，不参与回写与校验
          stock2_id: item.id,
          goods_name: item.name,
          goods_spec: item.spec,
          goods_unit: item.unit,
          goods_count: item.counts,
          goods_price: item.sales_price,
          goods_amount: item.sales_amount,
          goods_remark: '',
          song_huo_count: item.counts,
          song_huo_price: item.sales_price,
          song_huo_amount: item.sales_amount
        }
        return obj
      })
      // 已有明细时追加，保留手工新增行；空白行（未填品名）不重复保留
      if (this.selfDetail.goods_list.length) {
        const validRows = this.selfDetail.goods_list.filter((item) => item.goods_name)
        this.selfDetail.goods_list = [...validRows, ...orderRows]
      } else {
        this.selfDetail.goods_list = orderRows
      }
    },
    // 弹窗取消
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    // 弹窗确认
    popupPush(isPushAndPrint) {
      this.$refs.refForm.$refs.refForm.validate((valid) => {
        if (valid) {
          this.customerList.forEach((item) => {
            if (item.val === this.selfDetail.form_data.customer_uuid) {
              this.selfDetail.form_data.customer_name = item.key
              // 原写法把赋值写在 if 外，会被列表最后一项覆盖成错误客户id
              this.selfDetail.form_data.customer_id = item.id
            }
          })
          if (!this.selfDetail.form_data.delivery_date) {
            this.$message.error('请选择发货日期')
            return
          }
          // 明细校验：至少一行填写了品名（支持自由新增，不再强依赖销售订单）
          const validGoods = this.selfDetail.goods_list.filter((item) => item.goods_name)
          if (!validGoods.length) {
            this.$message.error('请至少添加一行商品明细（品名必填）')
            return
          }
          this.selfDetail.goods_list = validGoods
          this.$api({
            method: 'post',
            url: '/admin/gcvip/songHuo4/saveOrUpdate',
            data: this.selfDetail
          })
            .then((res) => {
              if (res.data.state === 'ok') {
                this.popupCancel()
                this.$emit('success')
                this.$message.success('保存成功')
                if (isPushAndPrint) this.popupPrint(res.data.delivery_id)
              }
            })
            .catch(() => {})
        }
      })
    },
    // 项-打印
    popupPrint(id) {
      window.open(`/new/delivery/print?id=${id}`, '_blank')
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
}
</style>
